import { Menu, Milestone, Users } from "lucide-react";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { useUser } from "@rhino-project/core/hooks";
import { useSignOutAction } from "@rhino-project/core/queries";
import { Link, NavLink } from "react-router-dom";

export default function GlobalHeader() {
  const user = useUser();
  const { mutate: signOut } = useSignOutAction();
  const initials = (user?.name || user?.email || "TD").split(/\s+|@/).filter(Boolean).slice(0, 2).map((part: string) => part[0]?.toUpperCase()).join("") || "TD";
  const navItems = [
    { label: "Home", href: "/" },
    { label: "Dual-Use On-Ramp", href: "/dual-use-on-ramp" },
    { label: "Opportunities", href: "/opportunities" },
    { label: "Resources", href: "/resources" },
  ];

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-foreground">
          <Milestone className="h-4 w-4 text-accent" />
          The Third Door
        </Link>

        <nav className="hidden items-center gap-2 md:flex">
          {navItems.map((item) => (
            <Button key={item.href} asChild variant="ghost" size="sm" className="text-muted-foreground">
              <NavLink to={item.href}>{item.label}</NavLink>
            </Button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" className="hidden md:inline-flex">
            <Users className="mr-2 h-4 w-4" />
            Pathway Switch
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon">
                <Avatar className="h-7 w-7">
                  <AvatarFallback>{initials}</AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-popover text-popover-foreground">
              {user ? (
                <DropdownMenuItem onClick={() => signOut()}>Sign out</DropdownMenuItem>
              ) : (
                <>
                  <DropdownMenuItem asChild>
                    <Link to="/login">Sign in</Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem asChild>
                    <Link to="/register">Create account</Link>
                  </DropdownMenuItem>
                </>
              )}
            </DropdownMenuContent>
          </DropdownMenu>

          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden">
                <Menu className="h-4 w-4" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="bg-popover text-popover-foreground">
              <div className="mt-6 flex flex-col gap-2">
                {navItems.map((item) => (
                  <Button key={item.href} asChild variant="ghost" className="justify-start">
                    <NavLink to={item.href}>{item.label}</NavLink>
                  </Button>
                ))}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}